export const LEDGER_ENTRY_DATE_TIME_LONG_FORMAT = "MMM d, yyyy h:mmaaa";
export const LEDGER_ENTRY_DATE_TIME_SHORT_FORMAT = "h:mmaaa";
export const LEDGER_ENTRY_DATE_TIME_POSTINGS_FORMAT = "MMMM dd, yyyy";
export const LEDGER_ENTRY_GROUP_DATE_FORMAT = "MMM d, yyyy";
export const LEDGER_ENTRY_GROUP_HEADER_DATE_FORMAT = "EEEE MMM d, yyyy";
